module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-from-left-0bb6d237832f96d74566fb1b9c93353b.svg";